import React, { useState } from 'react';
import './Header.css';

const Header = ({ darkMode, setDarkMode }) => {
  const [showProfile, setShowProfile] = useState(false);

  const userProfile = {
    name: 'John Doe',
    email: 'john.doe@example.com',
    phone: '+91 9876543210',
    location: 'Mumbai, Maharashtra'
  };

  return (
    <header className="header">
      <div className="header-container">
        <div className="logo">
          <span className="logo-icon">🐾</span>
          <span className="logo-text">PetAdopt</span>
        </div>

        <nav className="nav-links">
          <a href="#home" className="nav-link">Home</a>
          <a href="#about" className="nav-link">About Us</a>
          <a href="#contact" className="nav-link">Contact Us</a>
        </nav>

        <div className="header-actions">
          <button 
            className="dark-mode-toggle" 
            onClick={() => setDarkMode(!darkMode)}
            title={darkMode ? 'Light Mode' : 'Dark Mode'}
          >
            {darkMode ? '☀️' : '🌙'}
          </button>
          
          <div className="profile-container">
            <button 
              className="profile-icon"
              onClick={() => setShowProfile(!showProfile)}
            >
              <span className="profile-avatar">👤</span>
            </button>

            {showProfile && (
              <div className="profile-popup">
                <div className="profile-header">
                  <div className="profile-avatar-large">👤</div>
                  <h3>{userProfile.name}</h3>
                </div>
                <div className="profile-details">
                  <div className="profile-item">
                    <span className="profile-label">📧 Email:</span>
                    <span className="profile-value">{userProfile.email}</span>
                  </div>
                  <div className="profile-item">
                    <span className="profile-label">📱 Phone:</span>
                    <span className="profile-value">{userProfile.phone}</span>
                  </div>
                  <div className="profile-item">
                    <span className="profile-label">📍 Location:</span>
                    <span className="profile-value">{userProfile.location}</span>
                  </div>
                </div>
                <button className="profile-logout">Logout</button>
              </div>
            )}
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
